import React from "react";

import { getStatusLabel } from "../helpers";

/**
 * Situação da nota como etiqueta com bolinha de cor (BDM-887).
 *
 * A cor sozinha não pode carregar o significado — a etiqueta sempre mostra o
 * texto, e a bolinha só reforça a leitura em varredura rápida da lista.
 *
 * Com `action` a etiqueta vira botão: é assim que a nota com problema abre o
 * motivo. Na lista a linha inteira navega para o pedido, por isso o clique
 * aqui não pode subir.
 */
export const DocumentStatus = ({ status, action = null, title = null }) => {
    const content = (
        <>
            <i className={`status-dot`} />
            {getStatusLabel(status)}
        </>
    );

    if (!action) {
        return <span className={`fiscal-status-pill status-${status}`}>{content}</span>;
    }

    return (
        <button
            type={`button`}
            className={`fiscal-status-pill status-${status} clickable`}
            title={title}
            onClick={event => {
                event.stopPropagation();
                action();
            }}
        >
            {content}
        </button>
    );
};

export default DocumentStatus;
